"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.text = exports.blob = exports.arrayBuffer = exports.json = exports.getErrorMessage = exports.APIException = void 0;
var APIException = (function (_super) {
    __extends(APIException, _super);
    function APIException(detail) {
        if (detail === void 0) { detail = null; }
        var _this = _super.call(this, detail || 'HTTP error') || this;
        _this.type = null;
        _this.status = 500;
        _this.title = 'Internal Server Error';
        _this.detail = null;
        _this.instance = null;
        _this.detail = detail;
        return _this;
    }
    APIException.createAPIException = function (body) {
        var type = body.type, status = body.status, title = body.title, detail = body.detail, instance = body.instance, violations = body.violations;
        var exception = new APIException(detail);
        exception.status = status;
        exception.type = type;
        exception.title = title;
        exception.instance = instance;
        exception.violations = violations;
        return exception;
    };
    return APIException;
}(Error));
exports.APIException = APIException;
function getErrorMessage(errorType, e) {
    if (!window.navigator.onLine) {
        return 'Cannot connect. Please make sure you are connected to internet.';
    }
    else if (errorType instanceof TypeError) {
        return 'There was a problem fetching the response.';
    }
    else if (errorType instanceof SyntaxError) {
        return 'There was a problem parsing the response.';
    }
    else
        return e.message;
}
exports.getErrorMessage = getErrorMessage;
function json(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_1, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, fetch(url, options)];
                case 1:
                    response = _c.sent();
                    return [3, 3];
                case 2:
                    e_1 = _c.sent();
                    console.log({ e: e_1 });
                    throw new Error(getErrorMessage(e_1.constructor, e_1));
                case 3:
                    if (!(response.status >= 200 && response.status < 300)) return [3, 5];
                    return [4, response.json()];
                case 4: return [2, _c.sent()];
                case 5:
                    _b = (_a = APIException).createAPIException;
                    return [4, response.json()];
                case 6: throw _b.apply(_a, [_c.sent()]);
            }
        });
    });
}
exports.json = json;
function arrayBuffer(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_2, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, fetch(url, options)];
                case 1:
                    response = _c.sent();
                    return [3, 3];
                case 2:
                    e_2 = _c.sent();
                    throw new Error(getErrorMessage(e_2.constructor, e_2));
                case 3:
                    if (!(response.status >= 200 && response.status < 300)) return [3, 5];
                    return [4, response.arrayBuffer()];
                case 4: return [2, _c.sent()];
                case 5:
                    _b = (_a = APIException).createAPIException;
                    return [4, response.json()];
                case 6: throw _b.apply(_a, [_c.sent()]);
            }
        });
    });
}
exports.arrayBuffer = arrayBuffer;
function blob(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_3, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, fetch(url, options)];
                case 1:
                    response = _c.sent();
                    return [3, 3];
                case 2:
                    e_3 = _c.sent();
                    throw new Error(getErrorMessage(e_3.constructor, e_3));
                case 3:
                    if (!(response.status >= 200 && response.status < 300)) return [3, 5];
                    return [4, response.blob()];
                case 4: return [2, _c.sent()];
                case 5:
                    _b = (_a = APIException).createAPIException;
                    return [4, response.json()];
                case 6: throw _b.apply(_a, [_c.sent()]);
            }
        });
    });
}
exports.blob = blob;
function text(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_4, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, fetch(url, options)];
                case 1:
                    response = _c.sent();
                    return [3, 3];
                case 2:
                    e_4 = _c.sent();
                    throw new Error(getErrorMessage(e_4.constructor, e_4));
                case 3:
                    if (!(response.status >= 200 && response.status < 300)) return [3, 5];
                    return [4, response.text()];
                case 4: return [2, _c.sent()];
                case 5:
                    _b = (_a = APIException).createAPIException;
                    return [4, response.json()];
                case 6: throw _b.apply(_a, [_c.sent()]);
            }
        });
    });
}
exports.text = text;
//# sourceMappingURL=httpclient.js.map